import { styled } from '@mui/material/styles';
import { Box, Typography, Button, TextField } from '@mui/material';
import { fontSizes } from '../../../layouts/fontSizes';
import pallet from '../../../layouts/pallet';

const PaperWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%'
}));

const ModerationPaper = styled(Box)(() => ({
  padding: '16px',
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  width: '100%'
}));

const SectionTitle = styled(Typography)(() => ({
  fontSize: fontSizes.sectionTitle,
  fontWeight: 600
}));

const PageSectionTitle = styled(SectionTitle)(() => ({
  fontSize: '18px !important'
}));

const ModerationStatusLabel = styled(Typography)(() => ({
  fontWeight: 600,
  fontSize: '12px !important'
}));

const ModerationDisabledForLabel = styled(Typography)(() => ({
  fontWeight: 600,
  fontSize: '12px !important'
}));

const EmailsHelperText = styled(Typography)(({ theme }) => ({
  fontSize: '12px !important',
  color: pallet.lightBlueText,
  marginLeft: '16px',
  [theme.breakpoints.down(1260)]: {
    marginTop: '8px',
    marginLeft: '16px'
  }
}));

const ActionsContainer = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'end'
}));

const UpdateButton = styled(Button)(() => ({
  minWidth: 160
}));

const EmailsTextField = styled(TextField)(() => ({
  '& .MuiInputBase-root': {
    height: 'auto !important',
    paddingTop: '8px',
    paddingBottom: '8px',
    overflow: 'auto',
    width: '400px',
    marginLeft: '16px'
  },
  '& textarea': {
    maxHeight: '64px',
    overflow: 'auto !important'
  }
}));

export {
  PaperWrapper,
  ModerationPaper,
  SectionTitle,
  PageSectionTitle,
  ModerationStatusLabel,
  ModerationDisabledForLabel,
  EmailsHelperText,
  ActionsContainer,
  UpdateButton,
  EmailsTextField
};
